import { TranslateLoader, Translation } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';

import * as TranslationsTR from '../../../assets/i18n/tr.json';
import * as TranslationsEN from '../../../assets/i18n/en.json';

const TRANSLATIONS: Translation = {
  en: TranslationsEN,
  tr: TranslationsTR,
};

export class StaticTranslationLoader implements TranslateLoader {
  public getTranslation(lang: string): Observable<Translation | string> {
    const translation = TRANSLATIONS[lang];
    if (translation) {
      return of(translation);
    } else {
      console.error(`Unknown language: ${lang}`);
      return of({});
    }
  }
}
